import * as React from "react";
import { labelToDashes } from "../utils";
import { ListItemWithLinkOnly } from "./ListItemWithLinkOnly";
import { ListItemWithChildren, MenuType } from "./MenuItem";
import { useMenu } from "./useMenu";

type Props = {
  onClickOnAnyLink: () => void;
  onChildOpen: (isOpen: boolean) => void;
};

export function NewsSupportAbout({ onClickOnAnyLink, onChildOpen }: Props) {
  const [, , , items] = useMenu().items.all;

  return (
    <ul
      className="elm-list-none elm-m-0 elm-p-0"
      aria-label={`${items.children.map(item => item.label).join(", ")}`}
    >
      {items.children?.map(item =>
        item.children ? (
          <ListItemWithChildren
            shouldBeDisplayed={true}
            shouldSkipAnimation={true}
            key={labelToDashes(item.label)}
            menuType={MenuType.BACK_TITLE_ITEMS}
            item={item}
            parentIsOpen={false}
            onClickOnAnyLink={onClickOnAnyLink}
            onChildOpen={onChildOpen}
          />
        ) : (
          <ListItemWithLinkOnly
            shouldBeDisplayed={true}
            key={labelToDashes(item.label)}
            item={item}
            className="elm-border-gray-300 elm-border-0 elm-border-b elm-border-solid"
          />
        )
      )}
    </ul>
  );
}
